(() => {
  const DESKTOP_QUERY = '(min-width: 750px) and (pointer: fine)';
  const ZOOM_SCALE = 1.6;

  const initQuickZoom = (root) => {
    if (!root || root.dataset.quickZoomInitialized === 'true') return;
    root.dataset.quickZoomInitialized = 'true';

    const mediaQuery = window.matchMedia(DESKTOP_QUERY);
    if (!mediaQuery.matches) return;

    root.querySelectorAll('.tk-gallery__item').forEach((item) => {
      const image = item.querySelector('img.tk-gallery__image');
      if (!image) return;

      let frameId = null;
      let pendingX = 0.5;
      let pendingY = 0.5;

      item.classList.add('tk-quick-zoom');
      item.setAttribute('tabindex', '0');
      item.setAttribute('role', 'button');
      item.setAttribute('aria-label', image.alt ? `Click to zoom: ${image.alt}` : 'Click to zoom product image');
      item.setAttribute('aria-pressed', 'false');

      const applyPosition = () => {
        frameId = null;
        if (!item.classList.contains('is-zoomed')) return;

        const rect = item.getBoundingClientRect();
        const maxX = rect.width * (ZOOM_SCALE - 1) * 0.5;
        const maxY = rect.height * (ZOOM_SCALE - 1) * 0.5;
        const translateX = (0.5 - pendingX) * 2 * maxX;
        const translateY = (0.5 - pendingY) * 2 * maxY;

        image.style.transform = `translate3d(${translateX.toFixed(2)}px, ${translateY.toFixed(2)}px, 0) scale(${ZOOM_SCALE})`;
      };

      const resetPosition = () => {
        if (frameId) cancelAnimationFrame(frameId);
        frameId = null;
        pendingX = 0.5;
        pendingY = 0.5;
        image.style.removeProperty('transform');
      };

      const resetZoom = () => {
        item.classList.remove('is-zoomed');
        item.setAttribute('aria-pressed', 'false');
        resetPosition();
      };

      const toggleZoom = () => {
        const willZoom = !item.classList.contains('is-zoomed');

        root.querySelectorAll('.tk-gallery__item.is-zoomed').forEach((other) => {
          if (other !== item) {
            other.classList.remove('is-zoomed');
            other.setAttribute('aria-pressed', 'false');
            other.querySelector('img.tk-gallery__image')?.style.removeProperty('transform');
          }
        });

        item.classList.toggle('is-zoomed', willZoom);
        item.setAttribute('aria-pressed', String(willZoom));

        if (willZoom) {
          image.style.transform = `translate3d(0, 0, 0) scale(${ZOOM_SCALE})`;
        } else {
          resetPosition();
        }
      };

      item.addEventListener('click', (event) => {
        if (!mediaQuery.matches) return;
        if (event.target.closest('button, a, video, model-viewer')) return;
        event.preventDefault();
        toggleZoom();
      });

      item.addEventListener('mousemove', (event) => {
        if (!mediaQuery.matches || !item.classList.contains('is-zoomed')) return;

        const rect = item.getBoundingClientRect();
        pendingX = Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width));
        pendingY = Math.max(0, Math.min(1, (event.clientY - rect.top) / rect.height));

        if (!frameId) frameId = requestAnimationFrame(applyPosition);
      }, { passive: true });

      item.addEventListener('mouseleave', () => {
        if (!item.classList.contains('is-zoomed')) return;
        pendingX = 0.5;
        pendingY = 0.5;
        if (!frameId) frameId = requestAnimationFrame(applyPosition);
      });

      item.addEventListener('keydown', (event) => {
        if (!mediaQuery.matches) return;
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggleZoom();
        } else if (event.key === 'Escape') {
          resetZoom();
        }
      });

      const observer = new MutationObserver(() => {
        if (item.hidden || item.getAttribute('aria-hidden') === 'true') resetZoom();
      });
      observer.observe(item, { attributes: true, attributeFilter: ['hidden', 'aria-hidden'] });
    });
  };

  const boot = () => {
    document.querySelectorAll('[data-royal-product]').forEach(initQuickZoom);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('[data-royal-product]').forEach(initQuickZoom);
  });
})();
